"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createYAxis = exports.createXAxis = exports.createBarScale = exports.calculateBars = void 0;
const lodash_1 = __importDefault(require("lodash"));
const d3_1 = require("d3");
const utilities_1 = require("../../utilities");
const date_1 = require("../../utilities/date");
const calculateBars = _ref => {
  let {
    data,
    barScale,
    yScale
  } = _ref;
  const zeroY = yScale(0);
  const bars = data.data.map((_ref2, i) => {
    let {
      key,
      formatted,
      value
    } = _ref2;
    const isPositive = value >= 0;
    const yScaleValue = yScale(value);
    const y = isPositive ? yScaleValue : zeroY;
    const height = isPositive ? zeroY - y : yScaleValue - zeroY;
    const x = barScale(formatted);
    return {
      key,
      width: barScale.bandwidth(),
      height,
      color: isPositive ? data.color[i] : data.negativeColor[i],
      x,
      y
    };
  });
  return bars;
};
exports.calculateBars = calculateBars;
const createBarScale = _ref3 => {
  let {
    type,
    data,
    range,
    spacing: barSpacing,
    customDomain = [undefined, undefined]
  } = _ref3;
  const hasCustomDomain = customDomain.some(cd => cd !== undefined);
  const filteredDate = data.data.map(i => i.formatted).filter(i => {
    if (!hasCustomDomain) {
      return true;
    }
    if (customDomain[0] && i >= (0, date_1.dateParser)(customDomain[0], type)) {
      return true;
    }
    if (customDomain[1] && i <= (0, date_1.dateParser)(customDomain[1], type)) {
      return true;
    }
    return false;
  });
  const scale = (0, d3_1.scaleBand)().domain(filteredDate).range(range);
  const width = scale.bandwidth();
  const padding = lodash_1.default.min([lodash_1.default.round(barSpacing / width, 2), 1]);
  scale.paddingInner(padding);
  return {
    scale
  };
};
exports.createBarScale = createBarScale;
const createXAxis = _ref4 => {
  let {
    type,
    range,
    domain,
    hasCustomDomain,
    customTicks = undefined
  } = _ref4;
  const axisType = 'x';
  let newDomain = [...domain];
  let ticks;
  if (customTicks) {
    ticks = customTicks.map(i => (0, date_1.dateParser)(i, type));
    // remove out of bounds ticks
    if (hasCustomDomain) {
      ticks = ticks.filter(nt => nt >= newDomain[0] && nt <= newDomain[1]);
    } else {
      // extend domain to include custom ticks
      newDomain = [lodash_1.default.min([newDomain[0], ticks[0]]), lodash_1.default.max([newDomain[1], lodash_1.default.last(ticks)])];
    }
  }
  const scale = (0, utilities_1.calculateScale)(type, newDomain).range(range);
  ticks = (0, utilities_1.getAxisTicks)({
    axisType,
    scale,
    customTicks: ticks
  });
  return {
    domain: newDomain,
    ticks,
    scale
  };
};
exports.createXAxis = createXAxis;
const createYAxis = _ref5 => {
  let {
    type,
    range,
    domain,
    hasCustomDomain,
    customTicks = undefined
  } = _ref5;
  const axisType = 'y';
  let newDomain = [...domain];
  let ticks;
  if (customTicks) {
    ticks = (0, utilities_1.formatAxisData)(axisType, type, customTicks);
    // remove out of bounds ticks
    if (hasCustomDomain) {
      ticks = ticks.filter(nt => nt >= newDomain[0] && nt <= newDomain[1]);
    } else {
      // extend domain to include custom ticks
      newDomain = [lodash_1.default.min([newDomain[0], ticks[0]]), lodash_1.default.max([newDomain[1], lodash_1.default.last(ticks)])];
    }
  }
  const scale = (0, utilities_1.calculateScale)(type, newDomain).range(range).nice();
  ticks = (0, utilities_1.getAxisTicks)({
    axisType,
    scale,
    customTicks: ticks
  });
  return {
    domain: newDomain,
    ticks,
    scale
  };
};
exports.createYAxis = createYAxis;